import { Component, OnInit, ViewChild } from '@angular/core';
import { MensajeService } from 'src/app/services/mensaje.service';
import Swal from 'sweetalert2';
import { Title } from "@angular/platform-browser";
import { TITLE_PAGE } from 'src/app/constantes/title-page';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbCarouselConfig, NgbCarousel } from '@ng-bootstrap/ng-bootstrap';
import { BannerService } from '../../services/administrador/banner.service';
import { SeccionBannerRecibe } from 'src/app/models/administrador/seccion-banner-recibe';

class SeccionBanner {
  idSeccionBanner: number;
  orden: number;
  descripcionLector: string;
  descripcionTooltip: string;
  urlAsociada: string;
  targetBlank: string;
  imgColor: string;
  imgBlancoYNegro: string;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  @ViewChild('carousel') carousel: NgbCarousel;

  btnNombreboton = "Pausar";
  validarBanner = true;
  public pBooVerQueEsMVO: boolean = false;

  detenerCarrusel = false;
  fecha = new Date();

  listaSeccionBannerRecibe: SeccionBannerRecibe[] = new Array<SeccionBannerRecibe>();
  listaSeccionBanner: SeccionBanner[] = [];

  constructor(private mensajeService: MensajeService, private titleService: Title, private router: Router, private route: ActivatedRoute, private _config: NgbCarouselConfig, public bannerService: BannerService) {
    this.titleService.setTitle("Inicio: " + TITLE_PAGE);
    _config.interval = 5800;
    _config.showNavigationArrows = false;
    _config.showNavigationIndicators = false;
  }

  convertToCSV(objArray) {
    const array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    let str = "";
    for (let i = 0; i < array.length; i++) {
      let line = "";
      for (let index in array[i]) {
        if (line != "") line += ",";
        line += array[i][index];
      }
      str += line + "\r\n";
    }
    return str;
  }
  exportarCsv(headers, items, fileName) {
    if (headers) {
      items.unshift(headers);
    }
    const jsonObject = JSON.stringify(items);
    const csv = this.convertToCSV(jsonObject);
    const exportName = fileName + ".csv" || "export.csv";
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, exportName);
    } else {
      const link = document.createElement("a");
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", exportName);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }

  }
  descargar() {
    const headers = {
      id: 'Identificador',
      nombre: 'Nombre'
    };
    const data = [
      { id: 1, nombre: 'John Doe' },
      { id: 2, nombre: 'Juan' },
      { id: 3, nombre: 'Samanta' }
    ];
    this.exportarCsv(headers, data, 'nombres');
  }

  prueba() {
    this.mensajeService.visualizarConfirm(
      '¿Está seguro de finalizar la prueba? ',
      (result) => {
        if (result) {
          // this.ultima = true;
          this.mensajeService.visualizarConfirm('Tiene el resultado disponible,¿desea consultarlo?',
            (result) => {
              if (result) {
                console.log('ir resultado')
              } else {
                console.log('ir home')
              }
            })

          //  localStorage.setItem('estado','1')
          // this.pruebaOnlineService.enviarPreguntaPregunta(envio).subscribe(data =>{
          //   console.log(data);


          // })
          //Swal.fire('Se ha guardado tu prueba, mira tus resultados!', '', 'success')
          //this.router.navigate(['/dashboard/verResultados']);
        } else {
          Swal.fire('Continúa con la prueba', '', 'info')
        }
      });
  }
  cargar() {
    location.reload()
  }
  ngOnInit(): void {
    localStorage.clear();
    this.listarSeccionBanner();
  }
  ingresar() {
    this.router.navigate(['/IniciarSesion']);
  }
  parar() {
    this.carousel.pause();
  }
  playy() {
    this.carousel.cycle();
  }
  irNoticia() {
    let noticias = document.querySelector('.noticiasIr');
    noticias.scrollIntoView({ behavior: 'smooth' });
  }
  irQueEsMVO() {
    let noticias = document.querySelector('.QueEsMVOIr');
    noticias.scrollIntoView({ behavior: 'smooth' });
  }

  adminsitrarBanner() {
    if (this.validarBanner) {
      this.btnNombreboton = "Continuar";
      this.validarBanner = false;
      this.carousel.pause();
    } else {
      this.btnNombreboton = "Pausar";
      this.validarBanner = true;
      this.carousel.cycle();
    }

  }
  irContenido() {
    document.getElementById("idContenido").focus();
  }
  enlace() {
    this.router.navigateByUrl('http://oferta.senasofiaplus.edu.co/sofia-oferta/buscar-oferta-educativa.html');
  }

  DescargarManual() {
    const anchor = document.createElement('a');
    anchor.download = `manual_uso_sena.pdf`;
    anchor.href = './assets/pdf/manual_uso_sena.pdf';
    anchor.click();
    window.open('https://www.youtube.com/watch?v=sjrVYQZl7aw&t=0s');
  }

  listarSeccionBanner() {
    this.bannerService.getListAllSeccionBanner()
      .subscribe(data => {
        this.listaSeccionBannerRecibe = data.seccionBannerDtoList;
        for (let index = 0; index < this.listaSeccionBannerRecibe.length; index++) {
          if (Number(this.listaSeccionBannerRecibe[index].estadoSeccionBanner) == Number(1)) {
            let seccion = new SeccionBanner();
            seccion.idSeccionBanner = this.listaSeccionBannerRecibe[index].idSeccionBanner;
            seccion.orden = this.listaSeccionBannerRecibe[index].orden;
            seccion.descripcionLector = this.listaSeccionBannerRecibe[index].descripcionLector;
            seccion.descripcionTooltip = this.listaSeccionBannerRecibe[index].descripcionTooltip;
            seccion.urlAsociada = this.listaSeccionBannerRecibe[index].urlAsociada;
            if (this.listaSeccionBannerRecibe[index].targetBlank == "SI") {
              seccion.targetBlank = "_blank";
            } else if (this.listaSeccionBannerRecibe[index].targetBlank == "NO") {
              seccion.targetBlank = "_self";
            }
            let imgColor = "data:image/jpeg;base64," + this.listaSeccionBannerRecibe[index].imgColor;
            seccion.imgColor = imgColor;

            let imgBlancoYNegro = "data:image/jpeg;base64," + this.listaSeccionBannerRecibe[index].imgBlancoYNegro;
            seccion.imgBlancoYNegro = imgBlancoYNegro;

            this.listaSeccionBanner.push(seccion);
          }
        }
      },
        err => {
          console.log(err);
        });
  }

  mostrarAlerta(nombre: string, url: string, target: string) {
    Swal.fire({
      title: 'Redireccionamiento',
      text: "Usted está a punto de ingresar a un sitio externo de la sede electrónica del SENA. "
        + "A partir de este momento es responsabilidad de " + nombre + " el cumplimiento de las normas que regulan su relación. "
        + "Cualquier solicitud deberá ser dirigida al responsable de dicho sitio " + nombre + ". ¿Desea ingresar al sitio?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#E56000',
      cancelButtonColor: '#E56000',
      cancelButtonText: 'No',
      confirmButtonText: 'Si'
    }).then((result) => {
      if (result.isConfirmed) {
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.target = target;
        anchor.click();
      }
    });
  }

}
